<template>
  <v-container fluid ma-0 pa-0 px-3 >
    <Loading :isLoading="loading">
      <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  All Accounts
                </h2>
              </template>
                <span>All Accounts</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header ">Accounts - <span class="font-weight-bold">3</span></h4>
          </v-flex>
          <v-spacer></v-spacer>
          <v-divider vertical ></v-divider>
          <v-flex shrink fill-height class="action">
            <v-tooltip left color="secondary">
                  <v-btn
                icon
                flat
                slot="activator"
                >
                <v-icon color="success" size="24">add_circle</v-icon>
                  </v-btn>
                  <span>Create a new account</span>
                </v-tooltip>
          </v-flex>
        </v-layout>
      </div>
      <v-layout wrap pt-4>
        <template>
        <v-flex xs12 sm6 md6 lg3 xl2 px-2 mb-2>
          <v-hover>
            <v-card
              class="px-4 py-2 mb-2 rounded-3"
              id="teamcard-main"
              color="cardBackground"
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 5 : 2}`">
              <v-card-title class="pa-0 pb-2 pt-1">
                  <router-link class="no-link-style" style="position:relative; width:100%" to="/">
                  <v-flex xs12>
                    <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-1 pb-1 pr-3">Cigna</h3>
                  </v-flex>
                  <v-flex xs12 pr-4>
                    <h4 class="text-truncate">
                      <span class="primary--text body-1 opacity-54 pt-1">Nickname -</span>
                      <span
                              class="pl-1 pt-1 primary-text body-1 opacity-54 font-weight-bold"
                            >cigna</span>
                    </h4>
                  </v-flex>
                  </router-link>
              </v-card-title>
            </v-card>
          </v-hover>
          </v-flex>
        </template>
        <template>
        <v-flex xs12 sm6 md6 lg3 xl2 px-2 mb-2>
          <v-hover>
            <v-card
              class="px-4 py-2 mb-2 rounded-3"
              id="teamcard-main"
              color="cardBackground"
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 5 : 2}`">
              <v-card-title class="pa-0 pb-2 pt-1">
                  <router-link class="no-link-style" style="position:relative; width:100%" to="/">
                  <v-flex xs12>
                    <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-1 pb-1 pr-3">Caseblocks</h3>
                  </v-flex>
                  <v-flex xs12 pr-4>
                    <h4 class="text-truncate">
                      <span class="primary--text body-1 opacity-54 pt-1">Nickname -</span>
                      <span
                              class="pl-1 pt-1 primary-text body-1 opacity-54 font-weight-bold"
                            >CB</span>
                    </h4>
                  </v-flex>
                  </router-link>
              </v-card-title>
            </v-card>
          </v-hover>
          </v-flex>
        </template>
        <template>
        <v-flex xs12 sm6 md6 lg3 xl2 px-2 mb-2>
          <v-hover>
            <v-card
              class="px-4 py-2 mb-2 rounded-3"
              id="teamcard-main"
              color="cardBackground"
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 5 : 2}`">
              <v-card-title class="pa-0 pb-2 pt-1">
                  <router-link class="no-link-style" style="position:relative; width:100%" to="/">
                  <v-flex xs12>
                    <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-1 pb-1 pr-3">Scotcoin</h3>
                  </v-flex>
                  <v-flex xs12 pr-4>
                    <h4 class="text-truncate">
                      <span class="primary--text body-1 opacity-54 pt-1">Nickname -</span>
                      <span
                              class="pl-1 pt-1 primary-text body-1 opacity-54 font-weight-bold"
                            >scotcoin</span>
                    </h4>
                  </v-flex>
                  </router-link>
              </v-card-title>
            </v-card>
          </v-hover>
          </v-flex>
        </template>
      </v-layout>
    </Loading>
  </v-container>
</template>

<script>
import Loading from "@/components/shared/Loading.vue"

export default {
  name: "all-accounts",
  data: () => {
    return { loading: false }
  },
  components: { Loading }
}
</script>
